import { encryptData } from "Security/Crypto/Crypto";
import axiosInstance from "services/api/axiosInstance";
import {
    updateJobGetRequest,
    updateJobGetResponse,
    updateJobGetFailure,

    updateCategoryRequest,
    updateCategoryResponse,
    updateCategoryFailure,

    updateSortBy,
    updateSearchResults,

    updateIndividualRequest,
    updateIndividualResponse,
    updateIndividualFailure,
    updateFilterData,

    applyFilterRequest,
    applyFilterResponse,
    applyFilterFailure,

    getInvitedApplicantsRequest,
    getInvitedApplicantsResponse,
    getInvitedApplicantsFailure,
    updateInvitedApplicantFilterStatus,

    applicantSearchRequest,
    applicantSearchResponse,
    applicantSearchFailure

} from "Slices/SuperAdmin/Jobs";

export const handleSaJobGet = params => async (dispatch) => {
    try {
        dispatch(updateJobGetRequest(params))

        const { data } = await axiosInstance.post("/applicants_view_mail", { job_id: params?.job_id })
        if (data?.error_code === 200) {
            dispatch(updateJobGetResponse(data?.data))
            if (!params?.candidate_job_role) {
                if (params?.professional_id && typeof params?.professional_id === "number") {
                    dispatch(handleIndividualCandidateSelect({ job_id: params?.job_id, professional_id: params?.professional_id }))
                }
            }
        } else {
            dispatch(updateJobGetFailure(data?.message))
        }
    } catch (Err) {
        dispatch(updateJobGetFailure(Err?.message))
    }
}

export const handleSaJobCategoryStatus = params => async (dispatch) => {
    try {
        dispatch(updateCategoryRequest(params))

        const { data } = await axiosInstance.post("/filter_by_application_status", params)
        if (data?.error_code === 0) {
            dispatch(updateCategoryResponse(data?.data))
        } else {
            dispatch(updateCategoryFailure(data?.message))
        }
    } catch (Err) {
        dispatch(updateCategoryFailure(Err?.message))
    }
}

export const handleSortBy = (params) => (dispatch) => {
    let sorting = [];
    const candidatesList = Array.isArray(params?.candidatesListNoNMutable) ? params.candidatesListNoNMutable : [];

    switch (params?.sortBy) {
        case "A-Z":
            sorting = [...candidatesList].sort((a, b) => {
                if (a?.first_name?.toLowerCase() < b?.first_name?.toLowerCase()) {
                    return -1;
                }
                return 1;
            });
            break;

        case "Z-A":
            sorting = [...candidatesList].sort((a, b) => {
                if (b?.first_name?.toLowerCase() < a?.first_name?.toLowerCase()) {
                    return -1;
                }
                return 1;
            });
            break;

        default:
            sorting = [...candidatesList];
            break;
    }

    dispatch(updateSortBy({ sortby: params?.sortValue, candidatesList: sorting }));
}

export const handlesaJobSearch = params => dispatch => {
    let searchedResults = [];
    const searchValue = params?.searchValue?.toLowerCase().trim();
    if (params?.searchValue) {
        searchedResults = params?.candidatesListNoNMutable?.filter((v) => {
            const firstName = v?.first_name?.toLowerCase().trim() || '';
            const lastName = v?.last_name?.toLowerCase().trim() || '';

            return firstName.includes(searchValue) || lastName.includes(searchValue);
        });
    } else {
        searchedResults = params?.candidatesListNoNMutable;
    }
    dispatch(updateSearchResults({ searchValue: params?.searchValue, candidatesList: searchedResults }))
}

export const handleApplicantIdAppend = (params) => {
    let path = new URLSearchParams(window.location.search);
    let navigate = params?.navigate;
    let encrypt_applicant_id = encryptData(params?.applicant_id)
    //Update applicant id
    path.set("applicant_id", encrypt_applicant_id);

    //Update responsive page
    path.set("responsive", window.innerWidth <= 992 ? true : false);

    const newPath = `${window.location.pathname}?${path.toString()}`;
    navigate(newPath);
}

export const handleApplicantIdBack = (params) => {
    let path = new URLSearchParams(window.location.search);
    let navigate = params?.navigate;;
    //Update responsive page
    path.set("responsive", false);

    const newPath = `${window.location.pathname}?${path.toString()}`;
    navigate(newPath);
}

export const handleIndividualCandidateSelect = params => async (dispatch) => {
    try {
        dispatch(updateIndividualRequest())

        const { data } = await axiosInstance.post("/get_selected_professional_detail", params)
        if (data?.error_code === 0) {
            dispatch(updateIndividualResponse(data?.data))
        } else {
            dispatch(updateIndividualFailure())
        }
    } catch (Err) {
        dispatch(updateIndividualFailure())
    }
}

export const handleOnchangeFilter = params => dispatch => {
    if (params?.field === "skills") {
        let newSkills = []
        if (params?.value?.length) {
            const checkIfValueIsOthers = params?.value?.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length) {
                newSkills = params?.data?.map((skills) => {
                    return skills.label !== "Others" ? { ...skills, disabled: true } : skills
                })
            } else {
                newSkills = params?.data?.map((skills) => {
                    return skills.label === "Others" ? { ...skills, disabled: true } : skills
                })
            }
        } else {
            newSkills = params?.data?.map((skills) => {
                return { ...skills, disabled: false }
            })
        }
        dispatch(updateFilterData({ field: "skills", skills_checked: newSkills, skills: params?.value }))
    } else if (params?.field === "location_delete") {
        let deleteLocation = params?.data?.filter((v) => v !== params?.deletion_value)
        dispatch(updateFilterData({ field: "location_delete", location: deleteLocation }))
    } else {
        if (params?.place) {
            let countryComponent = params?.place?.find(component => component?.types?.includes('country'));
            let cityState = params?.place?.find(component => component?.types?.includes('locality'));
            dispatch(updateFilterData({ field: "location_push", location: `${cityState?.long_name},${countryComponent?.long_name}` }))
        } else {

        }
    }
}

export const handleSaApplyFilter = params => async (dispatch) => {
    let job_id = params?.job_id
    let skills = params?.seleced_filter_data?.skill?.map((v) => v.label)
    let location = params?.seleced_filter_data?.location?.map((v) => {
        const splitByComma = v?.split(",")
        const joinByAnd = splitByComma?.join("&&&&&")
        return joinByAnd
    })

    dispatch(applyFilterRequest())
    try {
        const { data } = await axiosInstance.post("/filter_professionals", { job_id, skills: skills || [], location: location || [] })
        if (data?.error_code === 0) {
            dispatch(applyFilterResponse(data?.data))
        } else {
            dispatch(applyFilterFailure(data?.message))
        }
    } catch (Err) {
        dispatch(applyFilterFailure(Err?.message))
    }
}

//Invited appplicants
export const handleGetSaInvitedApplicants = params => async (dispatch) => {
    try {
        dispatch(getInvitedApplicantsRequest())
        const { data } = await axiosInstance.post("/invited_applicants_view", params)

        if (data?.error_code === 0) {
            dispatch(getInvitedApplicantsResponse(data?.data))
        } else {
            dispatch(getInvitedApplicantsFailure(data?.message))
        }
    } catch (Err) {
        dispatch(getInvitedApplicantsFailure(Err?.message))
    }
}

export const handleSaInvitedApplicantsFilter = params => dispatch => {
    let filter_status = params?.status
    let applicant_data = params?.data?.invited_applicats_immutable
    let filtered_data = []
    if (["Invited from Best fit", "Invited from pool page"]?.includes(filter_status)) {
        filtered_data = applicant_data?.filter((value) => {
            if (value?.invited_mode === "from pool page" && filter_status === "Invited from pool page") {
                return value
            }

            if (value?.invited_mode !== "from pool page" && filter_status === "Invited from Best fit") {
                return value
            }
        })
    } else {
        filtered_data = applicant_data
    }
    dispatch(updateInvitedApplicantFilterStatus({ status: filter_status, data: filtered_data }))
}

//Invited Applicants search
export const handleSaInvitedApplicantSearch = params => async (dispach) => {
    try {
        dispach(applicantSearchRequest())
        const { data } = await axiosInstance.post("/invited_applicants_search", params)
        if (data.error_code === 200) {
            dispach(applicantSearchResponse(data?.data))
        } else {
            dispach(applicantSearchFailure())
        }
    } catch (Err) {
        dispach(applicantSearchFailure(Err.message))
    }
}